 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }



const subscriptionOnNext =
  (
    subscriptionName,
    onNextHandlers,
    atmosphere,
    router
  ) =>
  (result) => {
    if (!result) return
    const payload = result[subscriptionName]
    if (!payload) return
    const {fieldName} = payload
    const field = payload[fieldName]
    if (!field) {
      /* this happens when an onNextHandler exists
      but there is no matching fragment in the GQL subscription query. */
      console.error('Notification Subscription Payload received without field:', fieldName)
    }
    const handler = onNextHandlers[fieldName]
    _optionalChain([handler, 'optionalCall', _ => _(field, {...router, atmosphere})])
  }

export default subscriptionOnNext
